<template>
  <div>
    <div class="bloco-informativo">
      <div class="bloco-itens item-atalho" v-for="card in cardsInfo" :key="card.id">
        <v-card class="mx-auto" dark :color="card.color">
          <div>
              <v-card class="rounded-sm" :color="card.color"  >
                  <v-row align="center" class="ms-4" no-gutters >
                      <v-col no-gutters>
                        <v-row class="text-h4" no-gutters>
                            {{ card.quantidade }}
                        </v-row>
                        <v-row class="text-body-2" no-gutters>
                          {{ card.descricao }}
                        </v-row>
                      </v-col>
                      <v-col align="end" class="me-4">
                          <!-- <v-icon size="80" class="icone" >{{ card.icone }}</v-icon> -->
                           <v-icon size="80" class="icone">{{ card.icone }}</v-icon>
                      </v-col>
                  </v-row>
              </v-card>
          </div>
        </v-card>
      </div>
    </div>

    <div class="bloco-informativo-admin">
      <div class="bloco-itens-admin">
        <Window title="Matrículas" borderColor="#8E24AA">
          <div style="padding: 5px">
            <TesteGrafico :height="290" />
          </div>
        </Window>
      </div>
      <div class="bloco-itens-admin">
        <Window title="Escolas" borderColor="#66BB6A">
          <div style="padding: 5px">
            <TesteGraficoDois :height="290" />
          </div>
        </Window>
      </div>
    </div>

    <div class="bloco-informativo-admin">
      <div class="bloco-itens-admin">
        <Window title="Professores/Educadores por Etapa Escolar" borderColor="#F4511E">
          <div style="padding: 5px">
            <QntProfessorPorEtapaChart :height="290" />
          </div>
        </Window>
      </div>
      <div class="bloco-itens-admin">
        <Window title="Alunos Evadidos por Escola" borderColor="#40C4FF">
          <div style="padding: 5px">
            <QntAlunosEvadidosPorEscola :height="290" />
          </div>
        </Window>
      </div>
    </div>
  </div>
</template>

<script>
import TesteGrafico from './TesteGrafico';
import TesteGraficoDois from './TesteGraficoDois';
import QntProfessorPorEtapaChart from './charts/QntProfessorPorEtapaChart';
import QntAlunosEvadidosPorEscola from './charts/QntAlunosEvadidosPorEscola';
import Window from './Window';

export default {
  name: 'HomeAdministrador',
  components: {
    TesteGrafico,
    TesteGraficoDois,
    QntProfessorPorEtapaChart,
    QntAlunosEvadidosPorEscola,
    Window,
  },
  data() {
    return {
      cardsInfo: [
        { descricao: 'Alunos', quantidade: '20.000', icone: 'people', color: '#FF5722', },
        { descricao: 'Turmas', quantidade: 667, icone: 'school', color: '#4CAF50', },
        { descricao: 'Professores/Educadores', quantidade: '1.400', icone: 'people', color: '#FFC107', },
        { descricao: 'Dias Letivos Restantes', quantidade: 168, icone: 'timer', color: 'purple', },
      ],
    };
  },
}
</script>

<style lang="scss">
.bloco-informativo-admin {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;

  .bloco-itens-admin {
    padding: 13px 15px;
    width: 50%;
  }
}

@media only screen and (max-width: 800px){
  .bloco-informativo-admin {
    .bloco-itens-admin {
      width: 100%;
    }
  }
}
</style>
